import { useContext, useCallback, useMemo } from "react";
import { AnalyticsContext } from "@swiggy-private/checkout-core";
import { GiftingCouponCode, GiftingCartApiResponse } from "@swiggy-private/cart-types";
import { impressionCouponCodeForGifting } from "@cart-client/analytics/events/ApplyCoupon";
import { CartContext } from "@cart-client/contexts/CartContext";
import { buildGiftingExtraParamsForSavingsCornerAnalytics } from "@cart-client/helpers/Coupon";

export const useGiftingCouponCodeAnalytics = () => {
    const { impressionEvent } = useContext(AnalyticsContext);

    const { cartState } = useContext(CartContext);
    const { reviewedCart } = cartState;

    const giftingAnalyticsExtraParams = useMemo(
        () => buildGiftingExtraParamsForSavingsCornerAnalytics(reviewedCart?.data as GiftingCartApiResponse),
        [reviewedCart],
    );

    const handleImpressionForGiftingCouponCode = useCallback(
        (couponCode: GiftingCouponCode, applied?: boolean) => {
            impressionCouponCodeForGifting(impressionEvent, couponCode, applied, giftingAnalyticsExtraParams);
        },
        [impressionEvent, giftingAnalyticsExtraParams],
    );

    return {
        handleImpressionForGiftingCouponCode,
    };
};
